import GlsServiceApiClient from '@evidentid/gls-service-api-client';

export default new GlsServiceApiClient(deploy.WEB_PUBLIC_GLS_SERVICE_URL_PREFIX);
